<template>
  <div class="home" v-show="!$store.state.linkJurisdictionVisible &&
    !$store.state.IndicatorslinkVisible
    ">
    <!-- header -->
    <div class="logo" v-bind:class="{ collapsed: $store.state.collapsed }">
      <a @click="toHomePage">
        <!-- history -->

        <!-- test1 csk1-->
        <img v-if="
          $store.state.accountInfo.companyRow.version_type == 1 &&
          $store.state.accountInfo.companyRow.company_code == 'csk'
        " src="@/assets/icon_csk1.png" alt="logo" />
        <!-- test1 shxhs1-->
        <img v-else-if="
          $store.state.accountInfo.companyRow.version_type == 1 &&
          $store.state.accountInfo.companyRow.company_code == 'shxhs'
        " src="@/assets/icon_shxhs1.png" alt="logo" />
        <!-- test2 csk2-->
        <img v-else-if="
          $store.state.accountInfo.companyRow.version_type == 1 &&
          $store.state.accountInfo.companyRow.company_code == 'csk2'
        " src="@/assets/icon_csk2.png" alt="logo" />
        <!-- test2 shxhs2-->
        <img v-else-if="
          $store.state.accountInfo.companyRow.version_type == 1 &&
          $store.state.accountInfo.companyRow.company_code == 'shxhs2'
        " src="@/assets/icon_shxhs2.png" alt="logo" />
        <img src="@/assets/icon_s2p_pro.png" alt="logo"
          v-else-if="$store.state.accountInfo.companyRow.version_type == 1" />
        <!-- beta -->
        <img src="@/assets/icon_s2p_ult.svg" alt="logo" v-else />

        <!--        <h1 v-if="!$store.state.collapsed">-->
        <!--          <a-icon :component="IConSystemName" :style="{ fontSize: '64px' }" />-->
        <!--        </h1>-->
      </a>
      <p class="cp-txt">
        {{ $store.state.accountInfo.companyRow.company_name }}
      </p>
    </div>
    <!--    <div-->
    <!--      class="page-sider"-->
    <!--      v-bind:class="{-->
    <!--        collapsed: $store.state.collapsed,-->
    <!--        'hide-navbar': $store.state.hideNavbar-->
    <!--      }"-->
    <!--    >-->
    <!--      <div class="page-sider_inner">-->
    <!--        <div class="menu-collapsed" @click="toggleCollapsed">-->
    <!--          <a-icon-->
    <!--            :style="{-->
    <!--              color: '#9A9999'-->
    <!--            }"-->
    <!--            :type="$store.state.collapsed ? 'caret-right' : 'caret-left'"-->
    <!--            class="menu-collapsed-icon"-->
    <!--          />-->
    <!--        </div>-->
    <!--        <a-menu-->
    <!--          theme="dark"-->
    <!--          :selectedKeys="$store.state.subSelectedKeys"-->
    <!--          :openKeys="$store.state.subMenuOpenKeys"-->
    <!--          mode="inline"-->
    <!--          :inlineCollapsed="$store.state.collapsed"-->
    <!--          @click="subMenuSelect"-->
    <!--          @openChange="openChange"-->
    <!--        >-->
    <!--          <template v-for="item in $store.state.menuList">-->
    <!--            &lt;!&ndash; 无子 目前没有 功能不完备&ndash;&gt;-->
    <!--            <a-menu-item-->
    <!--              v-if="item.subMenuList && item.subMenuList.length === 0"-->
    <!--              :key="item.module_es"-->
    <!--            >-->
    <!--              <a-icon type="pie-chart" />-->
    <!--              <span>{{ item.module_name }}</span>-->
    <!--            </a-menu-item>-->
    <!--            &lt;!&ndash; 有子 &ndash;&gt;-->
    <!--            <a-sub-menu-->
    <!--              v-if="item.subMenuList && item.subMenuList.length > 0"-->
    <!--              :key="item.module_int"-->
    <!--            >-->
    <!--              <span slot="title">-->
    <!--                <a-icon :type="item.module_icon" />-->
    <!--                &lt;!&ndash;                <span v-if="state.collapsed" style="font-size:12px;">{{ item.module_name }}</span>&ndash;&gt;-->
    <!--                <span>-->
    <!--                  {{ item.module_name }}-->
    <!--                </span>-->
    <!--              </span>-->
    <!--              <template v-for="subItem in item.subMenuList">-->
    <!--                <a-menu-item :key="subItem.module_es">-->
    <!--                  <router-link-->
    <!--                    :to="subItem.module_es"-->
    <!--                    v-if="-->
    <!--                      $store.state.redListMap.hasOwnProperty(-->
    <!--                        subItem.module_int-->
    <!--                      ) && $store.state.redListMap[subItem.module_int] > 0-->
    <!--                    "-->
    <!--                  >-->
    <!--                    <a-badge-->
    <!--                      :count="$store.state.redListMap[subItem.module_int]"-->
    <!--                    >-->
    <!--                      <span style="padding-right: 13px;">{{-->
    <!--                        subItem.module_name-->
    <!--                      }}</span>-->
    <!--                    </a-badge>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    :to="subItem.module_es"-->
    <!--                    v-if="-->
    <!--                      !$store.state.redListMap.hasOwnProperty(-->
    <!--                        subItem.module_int-->
    <!--                      ) ||-->
    <!--                        ($store.state.redListMap.hasOwnProperty(-->
    <!--                          subItem.module_int-->
    <!--                        ) &&-->
    <!--                          $store.state.redListMap[subItem.module_int] === 0)-->
    <!--                    "-->
    <!--                  >-->
    <!--                    &lt;!&ndash;                    <a-badge dot>&ndash;&gt;-->
    <!--                    <span style="padding-right: 4px;">-->
    <!--                      {{ subItem.module_name }}-->
    <!--                    </span>-->
    <!--                    &lt;!&ndash;                    </a-badge>&ndash;&gt;-->
    <!--                  </router-link>-->
    <!--                </a-menu-item>-->
    <!--              </template>-->
    <!--            </a-sub-menu>-->
    <!--          </template>-->
    <!--        </a-menu>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="page-sider">
      <div class="page-sider_inner">
        <Sidebar ref="Sidebar" :isAlwaysCollapse="isAlwaysCollapse"></Sidebar>
      </div>
    </div>
    <div class="page-content" v-bind:class="{
      collapsed: $store.state.collapsed || isAlwaysCollapse,
      currentMenu: !isAlwaysCollapse && !$store.state.currentMenu,
      'hide-navbar': $store.state.hideNavbar
    }">
      <div class="page-header" v-bind:class="{ collapsed: $store.state.collapsed }">
        <div class="header-inner">
          <!-- left -->
          <div class="header-left" :style="'width:' + screenWidth + 'px'">
            <div class="top-menu-container"></div>
            <top-menu ref="topMenu" :menuList="$store.state.subSystemList" :selectedKeys="$store.state.mainSelectedKeys"
              @click="menuClick"></top-menu>
            <!-- menu -->
            <!--            <a-menu-->
            <!--              mode="horizontal"-->
            <!--              theme="dark"-->
            <!--              class="menu-main"-->
            <!--              :selectedKeys="$store.state.mainSelectedKeys"-->
            <!--              @click="menuClick"-->
            <!--            >-->
            <!--              <template v-for="(item, index) in subSystemList">-->
            <!--                <a-menu-item :key="item.module_int" class="menu-main_item"-->
            <!--                  >{{ item.module_name }}-->
            <!--                </a-menu-item>-->
            <!--              </template>-->
            <!--            </a-menu>-->
          </div>
          <!-- right -->
          <div class="header-right">
            <!--            <div class="vertical-line"><p></p></div>-->
            <!--            <span class="date"></span>-->
            <div class="avatar-group" v-if="accountInfo.accountRow">
              <a-avatar icon="user" />
              <span class="username">{{
                accountInfo.accountRow.realname
              }}</span>
            </div>
            <a-dropdown class="dropdown" v-if="accountInfo.quarterRow" @visibleChange="quarterVisibleChange">
              <a class="ant-dropdown-link" href="#">
                <span class="dropdown-quarter_name">{{
                  accountInfo.quarterRow.quarter_name
                }}</span>
                <a-icon type="down" v-if="!quarterVisible" />
                <a-icon type="up" :style="{ fontSize: '12px' }" v-if="quarterVisible" />
              </a>
              <a-menu slot="overlay" @click="quarterSelect">
                <a-menu-item v-for="item in accountInfo.quarterList" :key="item.quarter_id">
                  {{ item.quarter_name }}({{ item.region_name }})
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <div class="vertical-line">
              <p></p>
            </div>
            <div class="header-func">
              <div class="header-func_inner">
                <ul class="btn-list">
                  <!-- <li>
                    <a-badge count="12">
                      <a-icon
                        style="padding: 6px;font-size:16px;"
                        type="bell"
                      />
                    </a-badge>
                  </li> -->
                  <li>
                    <!-- <router-link
                      :to="{ name: 'userMyUpload' }"
                      title="我的上传"
                    > -->

                    <!-- @click="()=>$router.openNewWindow('userMyUpload')" -->
                    <p style="margin-left: 10px" title="我的上传" @click="() => $router.openNewWindow('userMyUpload')">
                      <a-badge :count="$store.state.importDoneCount" v-if="
                        $store.state.importDoneCount > 0 &&
                        $store.state.isShowImportDoneCount
                      ">
                        <a-icon style="padding: 4px; font-size: 16px" type="cloud-upload" />
                      </a-badge>
                      <a-icon v-else style="padding: 6px; font-size: 16px" type="cloud-upload" />
                    </p>
                    <!-- </router-link> -->
                  </li>
                  <li>
                    <!-- <router-link
                      :to="{ name: 'flowSystemMyDownload' }"
                      title="我的下载"
                    > -->
                    <p style="margin-left: 20px; margin-right: 20px" title="我的下载" @click="() => $router.openNewWindow('flowSystemMyDownload')
                      ">
                      <a-badge :count="$store.state.exportDoneCount" v-if="
                        $store.state.exportDoneCount > 0 &&
                        $store.state.isShowExportDoneCount
                      ">
                        <a-icon style="padding: 4px; font-size: 16px" type="cloud-download" />
                      </a-badge>
                      <a-icon v-else style="padding: 6px; font-size: 16px" type="cloud-download" />
                    </p>
                    <!-- </router-link> -->
                  </li>
                  <li>
                    <!-- <router-link :to="{ name: 'userCenter' }" title="个人中心"> -->
                    <p style="margin-right: 20px" title="个人中心" @click="() => $router.openNewWindow('userCenter')">
                      <a-icon type="user" />
                    </p>

                    <!-- </router-link> -->
                  </li>
                  <li @click="logout">
                    <a href="javascript:;" title="退出登录">
                      <a-icon type="logout" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 主要内容 -->
      <div class="main-content">
        <div v-if="
          ($store.state.accountInfo.quarterRow.is_admin == 1 ||
            $store.state.accountInfo.quarterRow.is_attached_admin == 1) &&
          cd_flow_limit_isShow
        ">
          <a-affix :offset-top="70">
            <a-alert message="已超出流向清洗条数限制，流向无法入库，请与上海正也科技联系。" :showIcon="false" banner />
          </a-affix>
        </div>
        <div v-else>
          <a-affix :offset-top="70">
            <a-alert v-if="ServiceLife" :message="ServiceLife_test" :showIcon="false" banner />
          </a-affix>
        </div>
        <router-view :key="$route.fullPath"></router-view>
        <!--        数据维护悬浮按钮-->
        <div class="float-btn" v-if="
          $store.state.funcModuleArray.indexOf(2030100) > -1 ||
          $store.state.funcModuleArray.indexOf(2020100) > -1 ||
          $store.state.funcModuleArray.indexOf(1020200) > -1 ||
          $store.state.funcModuleArray.indexOf(1010100) > -1 ||
          $store.state.funcModuleArray.indexOf(1030200) > -1 ||
          $store.state.funcModuleArray.indexOf(4010100) > -1
        ">
          <img v-show="$store.state.isFloatBtnOpen" src="~@/assets/img/float/btn_quick_use_pressed.svg"
            class="btn-toggle" @click.stop="toggleFloatBtn(false)" alt="关闭" />
          <img v-show="!$store.state.isFloatBtnOpen" src="~@/assets/img/float/btn_quick_use_default.svg"
            class="btn-toggle" @click.stop="toggleFloatBtn(true)" alt="数据维护" />
          <div class="popover" v-show="$store.state.isFloatBtnOpen">
            <h4>数据维护</h4>
            <p style="color: #999999; margin: 0; font-size: 12px">
              点击跳转到数据维护页面
            </p>
            <div class="img-container">
              <router-link to="/masterDataSystem/goods-manage"
                v-if="$store.state.funcModuleArray.indexOf(2030100) > -1">
                <img src="~@/assets/img/float/icon_product_maintenance.svg" alt="产品维护" class="img-item" />
              </router-link>
              <router-link to="/masterDataSystem/client-import-list"
                v-if="$store.state.funcModuleArray.indexOf(2020100) > -1">
                <img src="~@/assets/img/float/icon_file_maintenance.svg" alt="档案维护" class="img-item" />
              </router-link>
              <router-link to="/jurisdictionSystem/account-manage"
                v-if="$store.state.funcModuleArray.indexOf(1020200) > -1">
                <img src="~@/assets/img/float/icon_personnel_maintenance.svg" alt="人员维护" class="img-item" />
              </router-link>
              <router-link to="/jurisdictionSystem/department-manage"
                v-if="$store.state.funcModuleArray.indexOf(1010100) > -1">
                <img src="~@/assets/img/float/icon_framework_maintenance.svg" alt="架构维护" class="img-item" />
              </router-link>
              <router-link to="/jurisdictionSystem/area-esponsibility-relevance"
                v-if="$store.state.funcModuleArray.indexOf(1030200) > -1">
                <img src="~@/assets/img/float/icon_relational_matching.svg" alt="关系自动匹配" class="img-item" />
              </router-link>
              <router-link to="/flowSystem/fs-sales-data-import/1"
                v-if="$store.state.funcModuleArray.indexOf(4010100) > -1">
                <img src="~@/assets/img/float/icon_import_flow_direction.svg" alt="导入流向" class="img-item" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--修改密码模态框 第一次登陆-->
    <change-password-modal ref="changePasswordModal" scene="1"></change-password-modal>
    <!--加载动画-->
    <div class="global-loading" v-if="$store.state.globalLoading">
      <a-spin size="large" :style="{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%,-50%)'
      }" />
    </div>
    <div v-if="$store.state.isShowFooter" class="page-footer" v-bind:class="{ collapsed: $store.state.collapsed }">
      <img src="~@/assets/img/logo/footer_logo.png" alt="logo" class="footer-logo" />
      Copyright &copy;{{ currentYear }} by 上海正也信息科技有限公司
      <a href="https://beian.miit.gov.cn/" class="beian" target="_blank">沪ICP备14016032号-3</a>
    </div>

    <Tips ref="Tips"></Tips>

    <a-modal v-model="$store.state.linkJurisdictionVisible" title="提示" :footer="null" width="260px" :closable="false"
      :maskClosable="false">
      <div style="text-align: center; color: #111; padding: 20px 0px">
        当前岗位无此功能权限！
      </div>
    </a-modal>
    <a-modal v-model="$store.state.IndicatorslinkVisible" title="提示" :footer="null" width="300px" :closable="false"
      :maskClosable="false">
      <div style="text-align: center; color: #111; padding: 20px 0px">
        不在指标分解周期，无法导入指标！
      </div>
    </a-modal>

    <!-- <div id="notifcation-modal2" @click="onShowNotifcation">
      <div>{{ notifcationMessage }}</div>
      <div>
        <a-button type="link">
          查看
        </a-button>
      </div>
    </div> -->

    <div id="notifcation-modal">
      <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
        ">
        <div style="color: red">{{ notifcationModal.message }}</div>
        <div>
          <a-button @click="goCheckNotifcation" type="link"> 去查看 </a-button>
        </div>
      </div>
      <div style="position: absolute; top: 0px; right: 5px">
        <a-icon @click="onCloseNotifcation" type="close" />
      </div>
    </div>
  </div>
</template>

<script>
import { loginDetail, loginOut, toSendMsg } from '@/api/login'
import {
  getNavigationt,
  regionList,
  getClientActiveCls,
  getGlobalSetting,
  getNoticeJob
} from '@/api/common'
import watermark from 'watermark-dom'
import ChangePasswordModal from '@/components/ChangePasswordModal'
import TopMenu from '@/components/TopMenu'
import Sidebar from '@/components/sidebar/sidebar'
import Tips from '@/components/sidebar/tips'
import { IConSystemName } from '@/utils/svgImgs'
import { traverseDpTree } from '@/utils/util'
import { getAllDp } from '@/api/department'
import { getLoginFlowNum, getNowPeriod } from '@/api'
import store from '@/store'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { globalSetting } from '@/api/jurisdiction'
// import { themeChange } from '@/utils/settingConfig';

// import { redDot } from '@/api/account';
export default {
  name: 'home',
  components: { ChangePasswordModal, TopMenu, Sidebar, Tips },
  beforeCreate () {
    this.currentYear = new Date().getFullYear()
  },
  data: () => ({
    IConSystemName,
    // subSelectedKeys: [],
    // mainSelectedKeys: [],
    // subMenuOpenKeys: [],
    iscaidie:false,
    accountInfo: {},
    subSystemList: [],
    menuList: [],
    routeMap: {
      jurisdictionSystem: '1000000',
      masterDataSystem: '2000000',
      flowSystem: '4000000',
      bonusReturnSystem: '9000000',
      behaviorManage: '3000000',
      s2pDataApi: '1300000',
      studyPlatform: '12000000',
      orderSystem: '6000000',
      outsideSystem: '1400000',
      mg: '10000000'
    },
    timer: null,
    quarterVisible: false,
    screenWidth: '',

    cd_flow_limit_isShow: false,
    ServiceLife: false,
    ServiceLife_test: '',
    notifcationModal: {
      message: '',
      type: ''
    }
  }),

  created () {
    //获取地区列表
    this.getRegionList()
    //获取部门列表
    this.getDeptmentList()

    this._getLoginDetail()
    // 全局配置
    // getGlobalSetting(7).then(res => {
    //   this.$store.commit('setDoctorLevelType', res.data.config);
    // });
    // 我的下载，已完成数 小红点
    // this._getRedDot();
    // this.timer = setInterval(() => {
    //   this._getRedDot();
    // }, 60000);
    // 获取部门，缓存
    getAllDp().then((res) => {
      if (0 === res.status) {
        let departmentList = res.data
        let departmentListWithoutNum = res.data
        traverseDpTree(departmentList, 2)
        traverseDpTree(departmentListWithoutNum)
        this.$store.commit('setDepartmentList', departmentList)
        this.$store.commit(
          'setDepartmentListWithoutNum',
          departmentListWithoutNum
        )
      }
    })
    getClientActiveCls().then((res) => {
      if (0 === res.status) {
        let data = res.data
        this.$store.commit('setClientActiveCls', data)
      }
    })
    getNowPeriod({}).then((res) => {
      if (0 === res.status) {
        let data = res.data
        if (data) {
          this.$store.commit('setNowPeriod', data)
        } else {
          this.$store.commit('setNowPeriod', 1)
        }
      }
    })

    this.BannerNotice()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    ...mapActions({
      getRegionList: 'data/getRegionList',
      getDeptmentList: 'data/getDeptmentList'
    }),
    BannerNotice () {
      //是否到期
      this.ServiceLife = false
      //是否到期 提示语
      this.ServiceLife_test = ''

      getLoginFlowNum({}).then((res) => {
        if (res.status == 0) {
          //彩蝶流向清洗限制
          let cd_flow_limit = res.data.cd_flow_limit
            ? res.data.cd_flow_limit - 0
            : 0
          let flowNum = res.data.flowNum ? res.data.flowNum - 0 : 0

          if (flowNum >= cd_flow_limit) {
            let currentUrl = window.location.hash.split('#')[1].split('/')
            //只有彩蝶显示这个横幅
            console.log(currentUrl[1])
            if (currentUrl[1] == 'flowSystem') {
              this.cd_flow_limit_isShow = true
            } else {
              this.onSurplusDay()
            }
          } else {
            this.onSurplusDay()
          }

          if (this.ServiceLife || this.cd_flow_limit_isShow) {
            store.commit('setIsBanner', true)
          }
          this.setWatermark()
        }
      })
    },
    async onSurplusDay () {
      let res = await getNoticeJob()
      if (res.status == 0) {
        let targetIds = res.data || []
        let mySelfJobId = this.$store.state.accountInfo.quarterRow.job_id
        // 最大的管理员，附属管理员，配置了查看权限的职位 才能看到这个到期提醒
        if (
          (targetIds.includes(-1) &&
            this.$store.state.accountInfo.quarterRow.is_attached_admin == 1) ||
          targetIds.includes(mySelfJobId) ||
          this.$store.state.accountInfo.quarterRow.is_admin == 1
        ) {
          //软件使用期限剩余天数
          let surplus_day = ''
          //到期日
          let end_date = this.$store.state.accountInfo.companyRow.end_date
          // let end_date='2021-03-30'
          //当前日期
          let now_date = this.$store.state.accountInfo.companyRow.now_date
          //到期日 时间戳
          let end_date_stamp = new Date(end_date).valueOf() / 1000
          //当前日期 时间戳
          let now_date_stamp = new Date(now_date).valueOf() / 1000
          let day_stamp = 60 * 60 * 24 //一天的时间戳
          //软件使用期限剩余天数 时间戳
          let surplus_stamp = end_date_stamp - now_date_stamp

          if (surplus_stamp < day_stamp * 30) {
            surplus_day = parseInt(surplus_stamp / day_stamp)
            this.ServiceLife_test = `软件使用期限剩余${surplus_day}天！将于${moment(
              end_date
            ).format(
              'MM月DD日'
            )}到期，到期后可能将无法继续使用，请与上海正也科技联系`
            this.ServiceLife = true
          }
          this.cd_flow_limit_isShow = false
        }
      }
    },
    toHomePage () {
      this.$store.commit('setSubSelectedKeys', [])
      this.$store.commit('setHideNavbar', true)
      this.$store.commit('setMainSelectedKeys', ['/home'])
      // this.mainSelectedKeys = ['/home'];
      // this.subSelectedKeys = [];
      this.$router.push({ name: 'homePage' })
    },
    // 小红点
    _getRedDot (action, uid, info) {
      let that = this
      // 连接服务端
      let ws = io('https://' + 'ws.p2ps.vip' + ':2120')
      // 连接后登录
      ws.on('connect', function () {
        ws.emit('login', uid)
        // 触发消息推送
        toSendMsg().then((res) => {
          if (res.status == 0) {
            if (
              res.data.export_remind_items &&
              res.data.export_remind_items.length
            ) {
              that.notifcationModal.message =
                res.data.export_remind_items[0].message
              that.notifcationModal.type = 'export'
              that.onShowNotifcation()
            }
            if (
              res.data.import_remind_items &&
              res.data.import_remind_items.length
            ) {
              that.notifcationModal.message =
                res.data.import_remind_items[0].message
              that.notifcationModal.type = 'import'
              that.onShowNotifcation()
            }
          }
        })
      })
      ws.on('new_msg', function (msg) {
        let data = JSON.parse(msg.replace(/\&quot\;/g, '"'))
        data = data.message

        that.$store.commit('setExportDoneCount', data.export_done_count)
        that.$store.commit('setImportDoneCount', data.import_done_count)
        const redList = data.redList
        for (let item of redList) {
          // 待处理表格
          if (item.int === 4020100) {
            that.$store.commit('setPendingTableCount', item.count)
          }
          that.$store.commit('setRedList', redList)
        }
      })

      this.myWebSocket = ws
    },

    // 获取登陆详情
    async _getLoginDetail (quarter_id, is_change_quarter) {
      await loginDetail(quarter_id).then((res) => {
        if (0 === res.status) {
          this.$store.commit('SET_ACCOUNT_INFO', res.data)
          this.accountInfo = res.data
          const accountRow = res.data.accountRow
          // if (!accountRow.first_time) {
          //   this.$refs.changePasswordModal.modalOpen(accountRow.account_id);
          // }
          if (res.data.companyRow.company_code != 'jooyum') {
            // 小红点
            this._getRedDot(
              'login',
              `${res.data.companyRow.company_id}_${res.data.quarterRow.quarter_id}`,
              {
                quarter_id: res.data.quarterRow.quarter_id,
                account_id: res.data.accountRow.account_id,
                company_id: res.data.companyRow.company_id
              }
            )
          }

          if (is_change_quarter) {
            // 改变岗位后更新导航
            getNavigationt({ quarter_id: res.data.quarterRow.quarter_id }).then(
              (res) => {
                if (0 === res.status) {
                  let routeMap = {
                    jurisdictionSystem: '1000000',
                    masterDataSystem: '2000000',
                    flowSystem: '4000000',
                    bonusReturnSystem: '9000000',
                    behaviorManage: '3000000',
                    s2pDataApi: '1300000',
                    studyPlatform: '12000000',
                    orderSystem: '6000000',
                    outsideSystem: '1400000',
                    mg: '10000000'
                  }
                  const MODULE_NAME_MAP = {
                    1000000: '辖区管理',
                    2000000: '主数据',
                    4000000: '流向系统',
                    8000000: 'BI分析',
                    9000000: '奖金返利',
                    3000000: '行为管理',
                    1300000: '对接系统',
                    12000000: '学习平台系统',
                    6000000: '商务订单系统',
                    1400000: '云拜访',
                    10000000: '芒哥管理系统-工业端'
                  }
                  // 去除芒哥工业端
                  // why ???
                  // const subSystemList = res.data.subSystemList.filter(
                  //   (item) => item.module_int != 10000000
                  // )

                  const subSystemList = res.data.subSystemList

                  this.$store.commit(
                    'setFuncModuleArray',
                    res.data.funcModuleArray
                  )
                  subSystemList.map((item) => {
                    item.module_int = item.module_int + ''
                    if (MODULE_NAME_MAP.hasOwnProperty(item.module_int)) {
                      item.module_name = MODULE_NAME_MAP[item.module_int]
                    }
                  })
                  // 匹配当前导航
                  const regExp = /^\/(\w+)\//
                  const path = this.$route.path
                  if (regExp.test(path)) {
                    const systemName = path.match(regExp)[1]
                    if (routeMap.hasOwnProperty(systemName)) {
                      this.$store.commit('setHideNavbar', false)
                      const systemInt = routeMap[systemName]
                      // themeChange(systemInt + '');
                      // 选中对应顶级导航
                      // this.mainSelectedKeys = [systemInt];
                      this.$store.commit('setMainSelectedKeys', [systemInt])
                      subSystemList.map((item) => {
                        if (item.module_int === systemInt) {
                          // 获取对应顶级导航下的导航数据
                          // this.menuList = item.menuList;
                          this.$store.commit('setMenuList', item.menuList)
                          // 选中对应页面导航
                          // this.subSelectedKeys = [path];
                          this.$store.commit('setSubSelectedKeys', [path])
                          setTimeout(() => {
                            this.$store.commit('setGlobalLoading', false)
                          }, 500)
                        }
                      })
                    } else if (path !== '/redirect') {
                      // 为无下级导航页面 个人中心等
                      this.$store.commit('setHideNavbar', true)
                      setTimeout(() => {
                        this.$store.commit('setGlobalLoading', false)
                      }, 500)
                    }
                  } else if (path !== '/redirect') {
                    // 只有一级，首页等
                    this.$store.commit('setHideNavbar', true)
                    setTimeout(() => {
                      this.$store.commit('setGlobalLoading', false)
                    }, 500)
                    if (path === '/home') {
                      // this.mainSelectedKeys = ['/home'];
                      this.$store.commit('setMainSelectedKeys', ['/home'])
                    }
                  }
                  // 默认展开所有菜单
                  let subMenuOpenKeys = []
                  subSystemList.map((item) => {
                    // 默认展开所有菜单
                    for (let e of item.menuList) {
                      subMenuOpenKeys.push(e.module_int)
                    }
                  })
                  // this.subMenuOpenKeys = subMenuOpenKeys;
                  this.$store.commit('setSubMenuOpenKeys', subMenuOpenKeys)

                  // this.subSystemList = subSystemList;
                  subSystemList.unshift({
                    module_name: '首页',
                    module_int: '/home'
                  })
                  this.$store.commit('setSubSystemList', subSystemList)

                  this.getWidth()
                }
              }
            )
          }
        }
        this.getWidth()
      })
      await getClientActiveCls().then((res) => {
        if (0 === res.status) {
          let data = res.data
          this.$store.commit('setClientActiveCls', data)
        }
      })
    },
    menuClick ({ key }) {
      console.log(key, 'key===============>')
      if(key=="4000000"){
        this.iscaidie = true
      }else{
        this.iscaidie = false
      }
      this.$refs.Sidebar.showMenu()
      // this.mainSelectedKeys = [key + ''];
      this.$store.commit('setMainSelectedKeys', [key + ''])
      let subSystemList = this.$store.state.subSystemList
      //item.module_int为number  key为string 不要改成===
      const target = subSystemList.filter((item) => item.module_int == key)[0]
      if (target && target.menuList) {
        // this.menuList = target.menuList;
        this.$store.commit('setMenuList', target.menuList)
        this.$store.commit('setHideNavbar', false)
      } else {
        this.$store.commit('setHideNavbar', true)
        if (target.module_int === '/home') {
          this.$store.commit('setSubSelectedKeys', [])
          this.$router.push({ name: 'homePage' })
          this.$store.state.menuList = []
        }
      }
      console.log(target.module_int)
      if (
        [1000000, 2000000, 3000000, 4000000, 10000000, 1400000].indexOf(
          target.module_int - 0
        ) > -1
      ) {
        //埋点
        this.buryingPointTop(target.module_int)
      }

      // if (this.subSystemList[key].menuList) {
      //   this.menuList = this.subSystemList[key].menuList;
      // }
    },
    openChange (subMenuOpenKeys) {
      // this.subMenuOpenKeys = subMenuOpenKeys;
      this.$store.commit('setSubMenuOpenKeys', subMenuOpenKeys)
    },
    quarterSelect ({ key }) {
      this.$store.commit('save_quarter_id', key)
      console.log(this.$route.name)
      if (this.$route.name != 'homePage') {
        this.$router.push({ path: '/' })
      }
      this.quarterVisible = false
      this._getLoginDetail(key, true)
    },
    toggleCollapsed () {
      // this.subMenuOpenKeys = [];
      this.$store.commit('setSubMenuOpenKeys', [])
      let collapsed = this.$store.state.collapsed
      if (collapsed) {
        // 默认展开所有菜单
        let subMenuOpenKeys = []
        this.$store.state.subSystemList.map((item) => {
          // 默认展开所有菜单
          if (item.menuList) {
            for (let e of item.menuList) {
              subMenuOpenKeys.push(e.module_int)
            }
          }
        })
        this.$store.commit('setSubMenuOpenKeys', subMenuOpenKeys)
      }
      this.$store.commit('setCollapsed', !collapsed)
    },
    subMenuSelect ({ key }) {
      // this.subSelectedKeys = [key];
      this.$store.commit('setSubSelectedKeys', [key])
      // this.$router.push({ path: key });
    },
    logout () {
      loginOut().then((res) => {
        if (0 === res.status) {
          if (
            this.$store.state.accountInfo.companyRow &&
            this.$store.state.accountInfo.companyRow.company_code != 'jooyum'
          ) {
            this.myWebSocket.close()
          }
          this.$store.commit('setSubSelectedKeys', [])
          this.$store.state.menuList = []
          this.$router.replace({ name: 'login' })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    quarterVisibleChange (v) {
      this.quarterVisible = v
    },
    getWidth () {
      this.screenWidth =
        document.getElementsByClassName('header-inner')[0].clientWidth - 460
      this.$refs.topMenu.getShowNumber(
        this.screenWidth,
        this.$store.state.subSystemList.length
      )
      console.log(this.screenWidth)
    },
    toggleFloatBtn (status) {
      this.$store.commit('setFloatBtnStatus', status)
    },
    onShowNotifcation () {
      let dom = document.getElementById('notifcation-modal')
      dom.style.right = '20px'
      dom.style.visibility = 'visible'
      setTimeout(() => {
        this.onCloseNotifcation()
      }, 5000)
    },
    onCloseNotifcation () {
      let dom = document.getElementById('notifcation-modal')
      dom.style.right = '-150px'
      dom.style.visibility = 'hidden'
    },
    goCheckNotifcation () {
      if (this.notifcationModal.type == 'export') {
        this.$router.push({ name: 'flowSystemMyDownload' })
      }
      if (this.notifcationModal.type == 'import') {
        this.$router.push({ name: 'userMyUpload' })
      }
    },
    setWatermark () {
      watermark.load({ watermark_txt: '   ' })
      //手机号不需要了 username 这个地方也没有 报错了，先注释
      // let fhone =
      //   this.accountInfo.accountRow.username.substring(0, 3) +
      //   '*******' +
      //   this.accountInfo.accountRow.username.substring(
      //     this.accountInfo.accountRow.username.length - 3,
      //     this.accountInfo.accountRow.username.length
      //   )
      let text =
        this.accountInfo.companyRow.little_name + "  " +
        this.accountInfo.accountRow.realname
      text = text || ''
      let watermarkStting = JSON.parse(
        this.$store.state.accountInfo.companyRow.watermark_setting
      )
      console.log(watermarkStting, '水印')
      if (
        watermarkStting &&
        this.$route.path.includes('masterDataSystem/client-page')
      ) {
        if (watermarkStting.is_client == 1) {
          watermark.load({ watermark_txt: text, watermark_width: 300, watermark_x_space: 500, watermark_y_space: 300 })
        } else {
          watermark.load({ watermark_txt: ' ' })
        }
      } else if (
        watermarkStting &&
        (this.$route.path.includes('masterDataSystem/client-detail') ||
          this.$route.path.includes('masterDataSystem/client-update'))
      ) {
        if (watermarkStting.is_client == 1) {
          watermark.load({ watermark_txt: text, watermark_width: 300, watermark_x_space: 500, watermark_y_space: 300 })
        } else {
          watermark.load({ watermark_txt: ' ' })
        }
      } else if (
        watermarkStting &&
        (this.$route.path.includes('purchase-data') ||
          this.$route.path.includes('flowSystem/repertory-data') ||
          this.$route.path.includes('flowSystem/sales-data'))
      ) {
        if (watermarkStting.is_flow == 1) {
          watermark.load({ watermark_txt: text, watermark_width: 300, watermark_x: 0, watermark_y: -20, watermark_x_space: 600, watermark_y_space: 370 })
        } else {
          watermark.load({ watermark_txt: ' ' })
        }
      } else if (
        watermarkStting &&
        (this.$route.path.includes('behaviorManage/visiting') ||
          this.$route.path.includes('behaviorManage/visiting/detail') ||
          this.$route.path.includes('behaviorManage/bazaarActivity/list') ||
          this.$route.path.includes('behaviorManage/bazaarActivity/details'))
      ) {
        if (watermarkStting.is_task == 1) {
          watermark.load({ watermark_txt: text, watermark_width: 300, watermark_x_space: 500, watermark_y_space: 300 })
        } else {
          watermark.load({ watermark_txt: ' ' })
        }
      } else if (
        watermarkStting &&
        (this.$route.path.includes(
          'flowSystem/client-sales-ranking-statistics'
        ) ||
          this.$route.path.includes('flowSystem/goods-sales-statistics') ||
          this.$route.path.includes('flowSystem/client-purchase-statistics') ||
          this.$route.path.includes(
            'flowSystem/all-region-goods-sales-statistics'
          ) ||
          this.$route.path.includes('flowSystem/all-region-sales-statistics') ||
          this.$route.path.includes('flowSystem/province-sales-statistics'))
      ) {
        if (watermarkStting.is_flow_analyse == 1) {
          watermark.load({ watermark_txt: text, watermark_width: 300, watermark_x_space: 500, watermark_y_space: 300 })
        } else {
          watermark.load({ watermark_txt: ' ' })
        }
      } else {
        watermark.load({ watermark_txt: ' ' })
      }
    }
  },

  computed: {
    ...mapGetters(['init']),
    isAlwaysCollapse () {
      if(this.$store.state.mainSelectedKeys.includes('4000000') || this.iscaidie){
        if(this.$route.path.includes('/flowSystem/sales-data/flow-abutment') || this.$route.path.includes('/flowSystem/manual-pending-table')){
          return true
        }
      }
      
    },

    navigationtData () {
      return this.$store.state.subSystemList
    }
  },
  watch: {
    navigationtData (val) {
      this.getWidth()
    },
    $route (e) {
      setTimeout(() => {
        this.BannerNotice()
      }, 1000)
    }
  },
  mounted () {
    let that = this
    function debounce (fn, delay, that) {
      let handle
      return function (e) {
        clearTimeout(handle)
        handle = setTimeout(() => {
          fn(e, that)
        }, delay)
      }
    }
    function getW (e, that) {
      console.log(e, 'eeeee')
      that.$store.commit('data/setInnerHeight', e.target.innerHeight)
      let sumWidth = e.target.innerWidth
      that.screenWidth = sumWidth - 470 - 260
      if (that.screenWidth < 140) {
        that.screenWidth = 140
      }
      try {
        that.$refs.topMenu.getShowNumber(
          that.screenWidth,
          that.$store.state.subSystemList.length
        )
      } catch (e) { }
    }
    ; (function () {
      that.screenWidth =
        document.getElementsByClassName('header-inner')[0].clientWidth - 460
      setTimeout(function () {
        try {
          that.$refs.topMenu.getShowNumber(
            that.screenWidth,
            that.$store.state.subSystemList.length
          )
        } catch (e) { }
        // console.log(that.screenWidth,that.subSystemList.length)
      }, 1500)
    })()
    window.addEventListener('resize', debounce(getW, 100, this))
    this.getWidth()
    this.$refs.Sidebar.init()
    this.$refs.Tips.init()
  }
}
</script>
<style lang="less" scoped>
@import url('~ant-design-vue/dist/antd.less');
@import url('~@/assets/style/variable.less');

.logo {
  position: fixed;
  top: 0;
  left: 0;
  padding-left: 15px;
  height: @pageHeaderHeight;
  width: 200px;
  line-height: @pageHeaderHeight;
  background-color: @pageHeaderBgColor;
  overflow: hidden;
  transition: all 0.2s;
  z-index: 100;

  &.collapsed {
    width: @pageSiderCollapsedWidth;
  }

  img {
    display: inline-block;
    width: 170px;
    /*height: 32px;*/
    vertical-align: middle;
    margin-bottom: 13px;
  }

  h1 {
    display: inline-block;
    vertical-align: middle;
    height: 64px;
    color: #fff;
    font-size: 20px;
    margin: 0 0 0 12px;
    font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
      PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
      Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
    font-weight: 600;
  }
}

.page-content {
  padding-left: @pageSiderWidth;
  padding-top: calc(@pageHeaderHeight+61px);
  width: 100%;
  background-color: @pageContentBgColor;
  min-height: calc(~'100vh - 42px');
  min-width: 1280px;
  transition: padding-left 0.2s;

  &.collapsed {
    padding-left: @pageSiderCollapsedWidth;
  }

  &.hide-navbar {
    padding-left: 0 !important;
    padding-top: @pageHeaderHeight;
  }

  &.currentMenu {
    padding-left: calc(@pageSiderWidth - 50px);
    padding-top: calc(@pageHeaderHeight+61px);
  }

  .main-content {
    /*不能设置定位*/
    width: 100%;
  }
}

.page-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding-left: 200px;
  height: @pageHeaderHeight;
  background-color: @pageHeaderBgColor;
  transition: all 0.2s;
  z-index: 23;
  color: @pageHeaderColor;
  min-width: 800px;

  &.collapsed {
    padding-left: @pageSiderCollapsedWidth;
  }

  .vertical-line {
    display: inline-block;
    vertical-align: middle;
    padding: 10px 0;
    height: 100%;

    &>p {
      display: inline-block;
      height: 100%;
      border-right: 1px solid @pageHeaderColor;
    }
  }

  .header-inner {
    width: 100%;
    height: 100%;
    padding: 0 12px 0 0;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    background: @pageHeaderBgColor;
    color: @pageHeaderColor;

    a {
      color: @pageHeaderColor;
    }
  }

  .header-left {
    float: left;
    height: 100%;

    /*width: calc(~'100% - 400px');*/
    .menu-tab {
      padding: 0 24px;
      height: 100%;
      font-size: 20px;
      line-height: @pageHeaderHeight;
      vertical-align: middle;
      cursor: pointer;
    }
  }

  .header-right {
    float: right;
    height: 100%;

    & * {
      display: inline-block;
      vertical-align: middle;
    }

    .date {
      display: inline-block;
      padding: 0 16px;
      height: 100%;
      line-height: @pageHeaderHeight;
    }
  }

  .menu-main {
    display: inline-block;
    margin-left: 20px;
    background-color: @pageHeaderBgColor;
    vertical-align: middle;

    .menu-main_item {
      // margin-right: 8px;
      padding: 0;
      width: @mainMenuItemWidth;
      text-align: center;
      border-radius: 4px;
    }
  }
}

.avatar-group {
  height: 100%;
  line-height: @pageHeaderHeight;

  .username {
    display: inline-block;
    margin: 0 4px 0 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 80px;
  }
}

.dropdown {
  margin-right: 6px;
  height: 100%;
  line-height: 71px;
  color: @pageHeaderColor;

  .dropdown-quarter_name {
    display: inline-block;
    max-width: 96px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    vertical-align: top;
  }
}

.page-sider {
  position: fixed;
  padding-top: @pageHeaderHeight;
  padding-bottom: 2px;
  height: 100%;
  /*box-shadow: 2px 0 8px 0 rgba(29, 35, 41, 0.05);*/
  z-index: 23;
  transition: width 0.2s;

  &.collapsed {
    width: @pageSiderCollapsedWidth;
  }

  &.hide-navbar {
    width: 0 !important;
  }

  .page-sider_inner {
    position: relative;
    width: 100%;
    height: 100%;
    //overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .menu-collapsed {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);
      width: 18px;
      height: 40px;
      border-radius: 18px 0 0 18px;
      background: rgb(38, 41, 45);
      z-index: 1;
      cursor: pointer;

      .menu-collapsed-icon {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
      }
    }
  }
}

.header-func {
  height: 100%;

  .header-func_inner {
    /*padding-left: 19px;*/
    height: 100%;

    .btn-list {
      margin: 0;
      padding-left: 0;
      height: 100%;

      li {
        display: inline-block;
        height: 100%;
        line-height: @pageHeaderHeight;
        cursor: pointer;
        font-size: 16px;

        &:hover {
          background: rgba(255, 255, 255, 0.025);
        }

        a {
          padding: 0 10px;
        }
      }
    }
  }
}

.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000000;
  background: #f0f2f5;
}

.page-footer {
  margin-bottom: 20px;
  height: 16px;
  padding-left: @pageSiderWidth;
  color: #999;
  font-size: 11px;
  text-align: center;

  &.collapsed {
    padding-left: @pageSiderCollapsedWidth;
  }

  .footer-logo {
    margin-right: 20px;
    width: 120px;
    height: 22px;
  }

  .beian {
    padding-left: 10px;
    color: #999;
  }
}

.float-btn {
  position: fixed;
  z-index: 600;
  bottom: 6px;
  right: -1px;
  user-select: none;

  .btn-toggle {
    display: block;
    width: 54px;
    height: 54px;
    cursor: pointer;
  }

  .popover {
    position: absolute;
    padding: 7px;
    background: #fff;
    border-radius: 6px;
    top: -102px;
    right: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    h4 {
      font-size: 14px;
      margin: 0;
    }
  }

  .img-container {
    width: auto;
    white-space: nowrap;
    text-align: right;

    .img-item {
      display: inline-block;
      width: 54px;
      height: 54px;
      vertical-align: middle;
    }
  }
}

.cp-txt {
  color: #8a8b8f;
  position: absolute;
  top: 28px;
  /*text-align: center;*/
  /*width: 82%;*/
  font-size: 12px;
  line-height: 60px;
}

/deep/ .ant-alert {
  background: #f59a23;
  opacity: 0.9;
  color: #fff;
}

#notifcation-modal {
  width: 400px;
  height: 60px;
  border: 1px solid #f0f2f5;
  background: rgba(255, 255, 255, 0.8);
  position: fixed;
  right: -150px;
  top: 80px;
  visibility: hidden;
  padding: 13px;
  z-index: 999;
  border-radius: 5px;
  transition-property: all;
  transition-duration: 1s;
}

#notifcation-modal2 {
  width: 400px;
  height: 60px;
  background: rgba(151, 151, 151, 0.95);
  position: absolute;
  right: 20px;
  top: 180px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
  z-index: 999;
  border-radius: 5px;
}
</style>

